import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import {
    FaChartBar,
    FaMapMarkerAlt,
    FaListAlt,
    FaCalendarAlt,
    FaCreditCard,
    FaMoneyBillWave,
    FaUser,
    FaUsers,
    FaFileAlt,
    FaExclamationTriangle,
} from "react-icons/fa";
import { ROUTES } from "constants/routes-path";
import CardList from "components/Card/CardList";
import Loading from "components/Loading/Loading";
import { reportsService } from "services/reportsService";
import { useExportHandler } from "./useExportHandler";
import { MonthlyReportType } from "../../../constants/reports";

function ReportsList() {
    const [handleExportUsers, isLoadingExportUsers] = useExportHandler(
        reportsService.exportUsers,
        "usuarios.xlsx"
    );

    const [handleExportPermitteeSituation, isLoadingExportPermitteeSituation] = useExportHandler(
        reportsService.exportPermitteeSituation,
        "situacao_permissionarios.xlsx"
    );

    const [handleExportUnconfirmedRadarFines, isLoadingExportUnconfirmedRadarFines] = useExportHandler(
        reportsService.exportUnconfirmedRadarFines,
        "naoconfirmadasradar.xlsx"
    );

    const [handleExportFinesPaidPerMonthYearDetran, isLoadingExportFinesPaidPerMonthYearDetran] = useExportHandler(
        reportsService.exportFinesPaidPerMonthYearDetran,
        "pagamentos.xlsx"
    );

    const [handleExportFinesPaidPerMonthYearBank, isLoadingExportFinesPaidPerMonthYearBank] = useExportHandler(
        reportsService.exportFinesPaidPerMonthYearBank,
        "pagamentos.xlsx"
    );

    const reportsConfig = [
        {
            icon: FaChartBar,
            route: ROUTES.reportsManagerialPath,
            titleKey: "reports.managerial.title",
            descriptionKey: "reports.managerial.description",
        },
        {
            icon: FaMapMarkerAlt,
            route: ROUTES.reportsAgentTrackingPath,
            titleKey: "reports.agent-tracking.title",
            descriptionKey: "reports.agent-tracking.description",
        },
        {
            icon: FaListAlt,
            route: ROUTES.reportsViolationsQualitativePath,
            titleKey: "reports.violations-qualitative.title",
            descriptionKey: "reports.violations-qualitative.description",
        },
        {
            icon: FaCalendarAlt,
            titleKey: "reports.violations-by-agent.title",
            onClick: () => navigateToReport(MonthlyReportType.QUANTITATIVE_INFRACTIONS_AGENTS_MONTH.url),
            descriptionKey: "reports.violations-by-agent.description",
        },
        {
            icon: FaCalendarAlt,
            titleKey: "reports.violations-by-equipment.title",
            onClick: () => navigateToReport(MonthlyReportType.QUANTITATIVE_INFRACTIONS_EQUIPMENT_MONTH.url),
            descriptionKey: "reports.violations-by-equipment.description",
        },
        {
            icon: FaCalendarAlt,
            titleKey: "reports.violations-by-type.title",
            onClick: () => navigateToReport(MonthlyReportType.QUANTITATIVE_INFRACTIONS_TYPES_MONTH.url),
            descriptionKey: "reports.violations-by-type.description",
        },
        {
            icon: FaMoneyBillWave,
            onClick: handleExportFinesPaidPerMonthYearBank,
            titleKey: "reports.paid-fines-monthly.title",
            descriptionKey: "reports.paid-fines-monthly.description",
        },
        {
            icon: FaMoneyBillWave,
            titleKey: "reports.fines-summary.title",
            onClick: () => navigateToReport(MonthlyReportType.SUMMARY_VALUES_INFRACTIONS.url),
            descriptionKey: "reports.fines-summary.description",
        },
        {
            icon: FaMoneyBillWave,
            titleKey: "reports.fines-to-receive-monthly.title",
            onClick: () => navigateToReport(MonthlyReportType.VALUES_INFRACTIONS_TO_BE_RECEIVED_MONTH.url),
            descriptionKey: "reports.fines-to-receive-monthly.description",
        },
        {
            icon: FaMoneyBillWave,
            onClick: handleExportFinesPaidPerMonthYearDetran,
            titleKey: "reports.paid-fines-detran.title",
            descriptionKey: "reports.paid-fines-detran.description",
        },
        {
            icon: FaExclamationTriangle,
            onClick: handleExportUnconfirmedRadarFines,
            titleKey: "reports.unconfirmed-radar.title",
            descriptionKey: "reports.unconfirmed-radar.description",
        },
        {
            icon: FaUser,
            onClick: handleExportUsers,
            titleKey: "reports.users.title",
            descriptionKey: "reports.users.description",
        },
        {
            icon: FaUsers,
            onClick: handleExportPermitteeSituation,
            titleKey: "reports.permittees-situation.title",
            descriptionKey: "reports.permittees-situation.description",
        },
        {
            icon: FaFileAlt,
            titleKey: "reports.permittees-documents-monthly.title",
            onClick: () => navigateToReport(MonthlyReportType.QUANTITATIVE_PERMITTEES_DOCUMENTS_MONTH.url),
            descriptionKey: "reports.permittees-documents-monthly.description",
        },
    ];

    const navigateToReport = (type) => {
        window.open(ROUTES.monthlyReportPath.replace(":type", type), "_blank");
    }

    const isLoading = isLoadingExportUsers || isLoadingExportPermitteeSituation || isLoadingExportUnconfirmedRadarFines || isLoadingExportFinesPaidPerMonthYearDetran || isLoadingExportFinesPaidPerMonthYearBank;

    return (
        <>
            {isLoading && (
                <Box
                    position="fixed"
                    top="0"
                    left="0"
                    right="0"
                    bottom="0"
                    bg="rgba(255, 255, 255, 0.6)"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    zIndex="overlay"
                >
                    <Loading maxH={{ sm: "100px", md: "350px" }} />
                </Box>
            )}

            <Flex
                gap="5"
                direction="column"
                pt={{ base: "180px", sm: "155px", lg: "90px" }}
                px="30px"
            >
                <CardList items={reportsConfig} />
            </Flex>
        </>
    );
}

export default ReportsList;
